module.exports = __webpack_public_path__ + "img/img_guide_delete_account_2.c6e97be6.png";